<div class="details-flex-item" [ngClass]="{ 'right': field.Alignment == 'Right','text-size-large': field.TextSize == 'Large','space-below': field.Margin == 'Bottom'}">
 <div class="details-flex-item-label">{{field.Label}}</div>
 <div class="details-flex-item-value" *ngFor="let item of children"><ng-container [appRenderNode]="item"></ng-container></div>
</div>
